import React from "react";
import { IMenuProps } from "./MenuProps";
import { IAppConfig } from "../sharedInterfaces";
import { RingModel } from "../Model/RingModel";
import { IRingState } from "../Controller/RingStateController/RingStateController";

import "../styles";
import MenuIFR from "./MenuIFR/MenuIFR";
import MenuLUXE from "./MenuLUXE/MenuLUXE";
import MenuSimple from "./MenuSimple/MenuSimple";
//--

interface Props {
  menuType: "ifr" | "luxe" | "simple" | "simpleLuxe";
  menuProps: IMenuProps;
  isPlugin: boolean;
  appConfig: IAppConfig;
  isSave: boolean;
  hideRef: boolean;
  saveDesign: () => {};
  downloadSS: () => {};
  rings: RingModel[];
  ringState: IRingState;
  setShape: () => void;
}

interface State {}

export default class Menu extends React.Component<Props, State> {
  constructor(props) {
    super(props);
  }

  componentDidMount(): void {
    this.props.menuProps.setConfigId();
  }

  render() {
    const { menuType, menuProps } = this.props;
    let menu;

    if (menuType === "luxe") {
      menu = <MenuLUXE {...menuProps} />;
    } else if (menuType === "simple" || menuType === "simpleLuxe") {
      menu = (
        <MenuSimple
          menuProps={menuProps}
          menuType={menuType}
          isPlugin={this.props.isPlugin}
          appConfig={this.props.appConfig}
          isSave={this.props.isSave}
          saveDesign={this.props.saveDesign}
          downloadSS={this.props.downloadSS}
          hideRef={this.props.hideRef}
        />
      );
    } else {
      //Use IFR-style menu as default
      menu = (
        <MenuIFR
          {...menuProps}
          rings={this.props.rings}
          ringState={this.props.ringState}
          setShape={this.props.setShape}
        />
      );
    }

    return menu;
  }
}
